export const ONE_LOGIN_AUTHORITY = "https://noom.onelogin.com/oidc/2";
export const AUTH_COOKIE_NAME = "hive-auth";
export const REDIRECT_COOKIE_NAME = `${AUTH_COOKIE_NAME}-redirect`;
export const DEFAULT_CS_TOKEN_EXPIRATION = 604799;
export const DEFAULT_AUTO_LOGIN_COOKIE_NAME = "autologin_data";
export const cookieOptions = {
    path: "/",
    sameSite: "strict",
    secure: process.env.NODE_ENV === "production",
};
//# sourceMappingURL=constants.js.map